"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 *
 * @param root0 Opciones
 * @param root0.justIds Si sólo queres los Ids
 * @param root0.justActives  Si sólo queres los activos
 * @param firestore
 * @param uid
 * @param root0.justIds.justIds
 * @param root0.justIds.justActives
 * @param uid.justIds
 * @param uid.justActives
 * @param root0.justActives.justIds
 * @param root0.justActives.justActives
 * @returns Suscripciones
 */
async function getSubscriptions(firestore, uid, { justIds, justActives, }) {
    let subs;
    try {
        const path = `user/${uid}/subscriptions`;
        const subscriptionsReference = (0, firestore_1.collection)(firestore, path);
        const subscriptionsActiveReference = (0, firestore_1.query)(subscriptionsReference, (0, firestore_1.where)("active", "==", true));
        if (justActives) {
            subs = await (0, firestore_1.getDocs)(subscriptionsActiveReference);
        }
        else {
            subs = await (0, firestore_1.getDocs)(subscriptionsReference);
        }
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (subs.empty) {
        return [];
    }
    if (justIds === true) {
        return subs.docs.map((document) => document.id);
    }
    return subs.docs.map((document) => document.data());
}
exports.default = getSubscriptions;
